import React from "react";
import { useTranslation } from "react-i18next";
import MobileLayout from "../MobileLayout";
import logo from "../asset/logo/LOGO_ORANGE.svg";
import { resetCookieChoice } from "./cookieChoice";

// Privacy information for participants (linked from invites via |*PRIVACYLINK*|). Same layout as the other simple
// screens: MobileLayout with the logo on top, the app's orange for headings.
const SECTIONS = ["what", "why", "who", "winner", "support", "howLong", "roles", "rights", "cookies"];

export const PrivacyPage = () => {
  const [t] = useTranslation("global");
  return (
    <MobileLayout scrollable>
      <div style={{ display: "flex", justifyContent: "center", padding: "2rem 0 1rem" }}>
        <img height={60} src={logo} alt="Breefer" />
      </div>
      <div style={{ padding: "0 1.5rem 2rem", fontFamily: "Roboto, Arial, sans-serif", lineHeight: 1.5 }}>
        <h1 style={{ fontSize: "1.6rem", fontWeight: 400 }}>{t("privacy.title")}</h1>
        <p>{t("privacy.intro")}</p>
        {SECTIONS.map((key) => (
          <React.Fragment key={key}>
            <h2 id={key} style={{ fontSize: "1.2rem", fontWeight: 700, color: "#EB6608", marginTop: "1.5rem" }}>{t(`privacy.${key}.title`)}</h2>
            <p>{t(`privacy.${key}.text`)}</p>
            {key === "cookies" && (
              <button type="button" onClick={resetCookieChoice} style={{ background: "none", border: 0, padding: 0, color: "#EB6608", textDecoration: "underline", cursor: "pointer", fontSize: "1rem" }}>
                {t("cookieConsent.settings")}
              </button>
            )}
          </React.Fragment>
        ))}
      </div>
    </MobileLayout>
  );
};
